import { QuarryList } from '@/components/data/QuarryList';
import { SiteList } from '@/components/data/SiteList';
import { MaterialList } from '@/components/data/MaterialList';
import { ClientList } from '@/components/clients/ClientList';
import { TonKmRateTiersList } from '@/components/data/TonKmRateTiersList';
import { DwellRateTiersList } from '@/components/data/DwellRateTiersList';

/**
 * Karjerai / Klientai — the reference data a dispatcher opens every day.
 * Quarries and sites side by side because an order is always a pairing of
 * the two; materials and rate tiers below, since they are consulted rather
 * than edited on most visits.
 *
 * Company details, tariffs/assumptions, logins and the API key used to live
 * at the bottom of this same tab — settings touched once a year at most,
 * mixed in with the lists a dispatcher works from all day. They now have
 * their own "Administravimas" tab (see AdminView.jsx) so this one is left
 * with only the things this tab's name promises.
 *
 * Clients spans the full width at the top. It is the longest of these lists
 * (a fleet has more customers than quarries), it is the one that carries a
 * table rather than a handful of rows, and until now it had no UI at all —
 * client companies could only appear as a side effect of approving a portal
 * request, which left the ones already in the database invisible.
 */
export function DataView() {
  return (
    <div className="space-y-4">
      <ClientList />
      <div className="grid gap-4 xl:grid-cols-2">
        <QuarryList />
        <SiteList />
      </div>
      {/* Transporto kainodaros modeliai: tenant-wide rate tiers, not nested
          under any one quarry/vehicle the way QuarryPriceList is — so they
          get their own row here rather than living inside another list's
          expand state. Paired with MaterialList now that TenantSettings
          (its old row-mate) has moved to AdminView. */}
      <div className="grid gap-4 xl:grid-cols-2">
        <MaterialList />
        <TonKmRateTiersList />
      </div>
      <DwellRateTiersList />
    </div>
  );
}
